import { appInsights } from "../features/logging/ApplicationInsightsService"
import { ErrorMessage } from "../features/shared/components/ErrorMessage"

export const InternalError: React.FC = () => {
  return (
    <ErrorMessage
      sessionIdMessage={`SESSION ID: ${appInsights.context.sessionManager.automaticSession.id}`}
    />
  )
}
